import { Metamodel } from 'app/model/base/model';
import { FLOW } from 'app/model/adapters/dataflow/IDataflow';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { DataFlowExpressionUtils } from 'app/model/adapters/dataflow/expression.util';
import { BaseSortTransformation } from 'app/model/dataflow/basesorttransformation';
import { isTruthy } from 'app/model/dataflow/dataflow-expression-utilities';
import { BooleanDataFlowType } from 'app/model/dataflow/dataflow-datatype';

export abstract class BaseSortTransformationAdapter extends TransformationAdapter<BaseSortTransformation> {
    public async getDslScript(baseSortTransformation: BaseSortTransformation): Promise<string> {
        const props = baseSortTransformation.sortExpressions.map((sortExpression) => {
            // eslint-disable-next-line max-len
            return `${sortExpression.ascending ? 'asc' : 'desc'}(${DataFlowExpressionUtils.wrapExpressionWithEmptyValue(
                sortExpression.dataFlowExpression.expression
            )}, ${sortExpression.nullsFirst ? 'true' : 'false'})`;
        });

        if (isTruthy(baseSortTransformation.caseInsensitive)) {
            props.push(
                `caseInsensitive: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                    baseSortTransformation.caseInsensitive,
                    BooleanDataFlowType.TYPE
                )}`
            );
        }

        const extraConfigs = this.getExtraDSLConfigs(baseSortTransformation);
        if (extraConfigs && extraConfigs.length) {
            props.push(...extraConfigs);
        }

        const partition = TransformationAdapter.getPartitionDslScript(baseSortTransformation);

        const knownProps = [...props, partition].filter((c) => !!c).join(',\n\t');
        const unknownProps = this._getUnknownProps(baseSortTransformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');

        return (
            `${this._getInputStreams(baseSortTransformation)}` +
            ` ${this.getTransformationName(
                baseSortTransformation
            )}(${transformationData}) ${FLOW} ${this._getOutputStreams(baseSortTransformation)}`
        );
    }

    protected getTransformationName(transformation: BaseSortTransformation): string {
        return Metamodel.modelOf(transformation).name;
    }

    protected getExtraDSLConfigs(baseSortTransformation: BaseSortTransformation): string[] {
        return [];
    }
}
